import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const inputVariants = cva(
  // Base classes that apply to all variants
  [
    "leading-none uppercase font-[FSEX302]",
    "border rounded-none",
    "px-1 py-1 h-auto",
    "text-3xl",
    "disabled:cursor-not-allowed disabled:opacity-50",
    "focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0",
  ],
  {
    variants: {
      variant: {
        default: [
          "bg-interactive-bg text-gray-900",
          "disabled:text-gray-300",
          "placeholder:text-gray-600",
          "border-t-gray-400 border-l-gray-400 border-r-gray-800 border-b-gray-800",
          "shadow-[0.1rem_0.1rem_black]",
        ],
        dark: [
          "bg-black text-white",
          "disabled:text-gray-400",
          "placeholder:text-gray-400",
          "border-t-gray-600 border-l-gray-600 border-r-gray-900 border-b-gray-900",
          "shadow-[0.1rem_0.1rem_black]",
        ],
        character: [
          "bg-gray-drk text-gray-900",
          "disabled:text-gray-300",
          "placeholder:text-gray-600",
          "border-black",
        ],
      },
      inputWidth: {
        full: "w-full",
        flexible: "max-w-full flex-grow",
        fixed: "w-[11rem]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

interface InputProps
  extends React.ComponentProps<"input">,
    VariantProps<typeof inputVariants> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, variant, inputWidth, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(inputVariants({ variant, inputWidth }), className)}
        ref={ref}
        {...props}
      />
    );
  }
);

Input.displayName = "Input";

export { Input };
